/* Product-card colour behaviour — port of the image-swap in src/components/site/ProductCard.tsx.
 *  • Click a swatch  → swap the card image + active ring (and remember it as current).
 *  • Hover the card  → peek a DIFFERENT colour (data-hover-src); restore on leave.
 *    Hover is skipped on touch devices (no real hover), where swatches stay the way. */
(function () {
  var ACTIVE = ['border-primary', 'ring-2', 'ring-primary/50'];
  var IDLE = ['border-border/60', 'hover:border-primary/60'];
  var hoverable = !!(window.matchMedia && window.matchMedia('(hover: hover)').matches);

  // Hover-to-peek another colour.
  document.querySelectorAll('[data-card-image]').forEach(function (img) {
    img.__cur = img.getAttribute('src'); // current (default or selected) source
    if (!hoverable) return;
    var peek = img.getAttribute('data-hover-src');
    if (!peek) return;
    var card = img.closest('.group') || img.parentElement;
    if (!card) return;
    card.addEventListener('mouseenter', function () {
      if (peek && peek !== img.__cur) { img.removeAttribute('srcset'); img.src = peek; }
    });
    card.addEventListener('mouseleave', function () {
      if (img.__cur && img.src !== img.__cur) { img.removeAttribute('srcset'); img.src = img.__cur; }
    });
  });

  // Click a swatch → swap + remember as the current image.
  document.addEventListener('click', function (e) {
    var sw = e.target.closest('[data-swatch]');
    if (!sw) return;
    var card = sw.closest('.group');
    if (!card) return;
    var img = card.querySelector('[data-card-image]');
    var src = sw.getAttribute('data-img');
    if (img && src) { img.removeAttribute('srcset'); img.src = src; img.__cur = src; }
    // The visible ring/border lives on the inner dot <span> (the button is just a 44px hit area).
    card.querySelectorAll('[data-swatch]').forEach(function (b) {
      var d = b.querySelector('span') || b;
      d.classList.remove.apply(d.classList, ACTIVE);
      d.classList.add.apply(d.classList, IDLE);
    });
    var dot = sw.querySelector('span') || sw;
    dot.classList.remove.apply(dot.classList, IDLE);
    dot.classList.add.apply(dot.classList, ACTIVE);
  });
})();
